module.exports = __webpack_public_path__ + "static/index/img/baikal-605.1bec5e88.jpg";